// components/ui/SiteBanner.jsx
import { useState } from "react";
import { X, ChevronRight } from "lucide-react";

export default function SiteBanner() {
	const [isOpen, setIsOpen] = useState(true);

	return (
		<>
			{/* Panneau d'information */}
			<div
				className={`
					fixed left-4 bottom-4 z-50
					w-[320px] max-w-[calc(100vw-32px)]
					transition-transform duration-500 ease-in-out
					${isOpen ? "translate-x-0" : "-translate-x-[calc(100%+16px)]"}
				`}
			>
				<div className="relative bg-espresso text-warm-alabaster shadow-2xl rounded-xl border border-latte-gold/20">
					{/* Bouton X : visible uniquement quand le panneau est ouvert */}
					<button
						type="button"
						onClick={() => setIsOpen(false)}
						aria-label="Fermer les informations"
						className="
							absolute -right-3 -top-3
							w-8 h-8
							flex items-center justify-center
							rounded-full
							bg-latte-gold
							text-espresso
							shadow-lg
							hover:scale-110
							transition-all duration-200
							z-10
						"
					>
						<X className="w-4 h-4" />
					</button>

					<div className="p-5">
						<div className="space-y-1">
							<p className="text-sm font-semibold text-latte-gold">
								Modification du site internet
							</p>

							<p className="text-xs leading-relaxed text-warm-alabaster/80">
								🆕 Ajout des produits existants sur le site
							</p>

							<p className="text-xs leading-relaxed text-warm-alabaster/80">
								🆕 Ajout d&apos;un système de panier et de paiement en ligne
							</p>

							<p className="text-xs leading-relaxed text-warm-alabaster/80">
								🆕 Ajout d&apos;un système de gestion des commandes pour
								l&apos;équipe
							</p>
						</div>

						<div className="mt-4 pt-3 border-t border-warm-alabaster/10">
							<div className="flex items-center justify-between text-xs text-warm-alabaster/80">
								<span>Dernière mise à jour :</span>
								<span className="font-semibold">4 août 2026</span>
							</div>

							<div className="mt-2 flex items-center justify-between text-xs text-warm-alabaster/80">
								<span>Version :</span>
								<span className="font-semibold">v2.0.0</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Languette : visible uniquement quand le panneau est fermé */}
			<button
				type="button"
				onClick={() => setIsOpen(true)}
				aria-label="Afficher les informations"
				className={`
					fixed left-0 bottom-4 z-40
					w-10 h-16
					flex items-center justify-center
					bg-espresso
					text-latte-gold
					rounded-r-lg
					shadow-lg
					border border-latte-gold/20
					transition-all duration-500 ease-in-out
					hover:w-12
					${
						isOpen
							? "opacity-0 pointer-events-none -translate-x-full"
							: "opacity-100 translate-x-0"
					}
				`}
			>
				<ChevronRight className="w-5 h-5" />
			</button>
		</>
	);
}
